/**
 * @file: useJobTitlePicker.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { withPrompt } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import { useActionSheet } from '@expo/react-native-action-sheet';

const PredefinedJobTitles = [
  '服务技师',
  '服务顾问',
  '门店经理',
  '营销专员',
  '其他...',
];

export const useJobTitlePicker = (onChange: (title: string) => any) => {
  const { showActionSheetWithOptions } = useActionSheet();
  return usePersistFn(() => {
    showActionSheetWithOptions(
      {
        title: '设置您的工作职位',
        options: [...PredefinedJobTitles, '取消'],
        cancelButtonIndex: PredefinedJobTitles.length,
      },
      async buttonIndex => {
        if (buttonIndex == null || buttonIndex === PredefinedJobTitles.length) {
          return;
        }
        if (buttonIndex === PredefinedJobTitles.length - 1) {
          const title = await withPrompt({
            title: '设置您的工作职位',
            message:
              '注意工作职位只是一个名称，不是您的工作角色，您可以随意填写',
          });
          if (title) {
            onChange(title);
          }
        } else {
          onChange(PredefinedJobTitles[buttonIndex]);
        }
      },
    );
  });
};
